import script from "./ProviderInformationFormPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderInformationFormPreview.vue?vue&type=script&setup=true&lang=js"

import "./ProviderInformationFormPreview.vue?vue&type=style&index=0&id=2da44f9c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da44f9c"]])

export default __exports__